/**
 * @file Hooks related to the shared Redux state. These should be used instead of the provided Redux hooks.
 * Provided by https://redux.js.org/usage/usage-with-typescript
 */

import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";

/** A statically-typed version of the Redux useDispatch */
export const useAppDispatch: () => AppDispatch = useDispatch;

/** A statically-typed version of the Redux useSelector */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
